import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import './Admin.css';

const ManageWebStories = () => {
    const [stories, setStories] = useState([]);
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem('token');

    // ✅ LIVE URL (Change to localhost if testing locally)
    const API_URL = 'https://indiajagran-backend.onrender.com';

    useEffect(() => {
        // ✅ FIX: Function moved inside useEffect
        const fetchStories = async () => {
            try {
                const { data } = await axios.get(`${API_URL}/web-stories/admin/all`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setStories(data);
                setLoading(false);
            } catch (error) {
                console.error("Error loading stories", error);
                setLoading(false);
            }
        };

        fetchStories();
        // eslint-disable-next-line
    }, []); // Empty dependency array means run once on mount

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this story?")) {
            try {
                await axios.delete(`${API_URL}/web-stories/${id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                // Remove from UI
                setStories(stories.filter(story => story._id !== id));
            } catch (error) {
                alert("Failed to delete story");
            }
        }
    };

    if (loading) return <div className="admin-container">Loading Stories...</div>;

    return (
        <div className="admin-container">
            <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px'}}>
                <h2>Manage Web Stories ({stories.length})</h2>
                <Link to="/admin/web-stories/create" className="btn-primary" style={{textDecoration:'none', padding:'10px 20px', background:'green', color:'white', borderRadius:'5px'}}>
                    + Create New Story
                </Link>
            </div>

            <div className="stories-grid" style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(250px, 1fr))', gap:'20px'}}>
                {stories.map(story => (
                    <div key={story._id} className="story-card-admin" style={{border:'1px solid #ddd', borderRadius:'10px', overflow:'hidden', background:'white', boxShadow:'0 2px 5px rgba(0,0,0,0.1)'}}>
                        <div style={{height:'200px', overflow:'hidden'}}>
                            <img src={story.coverImage} alt={story.title} style={{width:'100%', height:'100%', objectFit:'cover'}} />
                        </div>
                        <div style={{padding:'15px'}}>
                            <h4 style={{margin:'0 0 10px 0', fontSize:'1rem'}}>{story.title}</h4>
                            <p style={{fontSize:'0.8rem', color:'#666'}}>{new Date(story.createdAt).toLocaleDateString()}</p>
                            
                            <div style={{display:'flex', gap:'10px', marginTop:'15px'}}>
                                <Link to={`/admin/web-stories/edit/${story._id}`} style={{flex:1, background:'#3b82f6', color:'white', textAlign:'center', padding:'8px', borderRadius:'5px'}}>
                                    <FaEdit />
                                </Link>
                                
                                <a href={`${API_URL}/web-stories/${story.slug}`} target="_blank" rel="noreferrer" style={{flex:1, background:'#64748b', color:'white', textAlign:'center', padding:'8px', borderRadius:'5px'}}>
                                    <FaEye />
                                </a>

                                <button onClick={() => handleDelete(story._id)} style={{flex:1, background:'#ef4444', color:'white', border:'none', padding:'8px', borderRadius:'5px', cursor:'pointer'}}>
                                    <FaTrash />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ManageWebStories;